import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 30px;
  background-color: #00807e;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  @media (max-width: 768px) {
    height: auto;
    font-size: 13px;
    flex-wrap: wrap;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

const Announcement = () => (
  <Container>
    <p>🎉 🎉Hurry Up. Raining Discount on Orders above $2500</p>
  </Container>
);

export default Announcement;
